import script from "./ResourceCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceCalendar.vue?vue&type=script&setup=true&lang=js"

import "./ResourceCalendar.vue?vue&type=style&index=0&id=0dd5f6ca&lang=css"

const __exports__ = script;

export default __exports__